import { apiFetch } from './client';
import type { RunStatus } from '../components/StatusChip';

export interface RunSummary {
  totalRevenue: number;
  totalAdSpend: number;
  blendedROAS: number;
  totalSessions: number;
  totalNewContacts: number;
  totalOrders: number;
  conversionRate: number;
  averageOrderValue: number;
}

export interface Run {
  runId: string;
  triggeredBy: 'cron' | 'cli';
  status: RunStatus;
  period: { from: string; to: string };
  sources: string[];
  succeeded: string[];
  failed: string[];
  summary: RunSummary;
  durationMs: number;
  createdAt: string;
}

export interface RunError {
  runId: string;
  source: string;
  reason: string;
  retriesAttempted: number;
  createdAt: string;
}

export interface RunSnapshot {
  runId: string;
  source: string;
  period: { from: string; to: string };
  collectedAt: string;
  metrics: Record<string, number | undefined>;
  sheetMetrics?: Record<string, number>;
  planSheetMetrics?: Record<string, number>;
}

export function listRuns(limit = 50, signal?: AbortSignal) {
  return apiFetch<{ runs: Run[] }>(`/api/runs?limit=${limit}`, { signal });
}

export function fetchRun(runId: string, signal?: AbortSignal) {
  return apiFetch<{ run: Run; snapshots: RunSnapshot[]; errors: RunError[] }>(`/api/runs/${encodeURIComponent(runId)}`, { signal });
}

export function triggerRun(type: 'latest' | 'historical') {
  return apiFetch<{ status: string; type: string }>('/api/runs/trigger', { method: 'POST', body: { type } });
}
